module.exports = __webpack_public_path__ + "img/marker--smile-hearth-eyes.37f2950.svg";